import { SourceTag } from '@app/routes/content/components/source-tag';
import { Recording } from '@app/routes/content/domain';
import { formatDate, formatDuration } from '@app/routes/content/utils';
import { useAppSelector } from '@app/store';
import React from 'react';

import { selectRecording } from '../../../selector';

export const HeaderSection = () => {
  const recording = useAppSelector(selectRecording) as Recording;
  const { created_at, duration } = recording || {};
  return (
    <div className="flex items-center gap-5">
      <SourceTag
        recording={recording}
        className="flex items-center gap-0.5 px-2 h-7 bg-spring-neutral-b5 rounded-[21px] text-white text-xs font-medium leading-8"
      />
      <span className="text-spring-neutral-b2 text-xs font-medium">
        {formatDate({
          locale: 'en-US',
          date: created_at || '',
          style: 'medium',
        })}
      </span>
      <span className="text-spring-neutral-b2 text-xs font-medium">
        {formatDuration(duration)}
      </span>
    </div>
  );
};
